export const translationKeys = {
  NAMESPACE: 'Text_Area',
  INLINE_ERROR_MESSAGE_DEFAULT_ERROR_MESSAGE:
    'Text_Area_On_Stage_Error_Text_Label',
} as const;

export const experimentWrapperElement = 'textbox-wrapper-inside-experiment';
